export class Updatepersonalinfo {
    PATIENT_ACCOUNT: any = "";
    PRACTICE_CODE: any = "";
    ADDRESS: any = "";
    ZIP: any = "";
    HOME_PHONE: any = "";
    CITY: any = "";
    STATE: any = "";
    ETHNICITY: any = "";
    ETHNICITY2: any = "";
    LANGUAGE: any = "";
    RACE: any = "";
    GENDER: any = "";
    PHARMACY_ID: any = "";
    PHARMACY2_ID: any = "";
    PHARMACY3_ID: any = "";
    WORK_PHONE: any = "";
    PICTURE_ADDRESS: any = "";
  EMAIL_ADDRESS: any = "";
  CELL_PHONE: any = "";
}
export class GetRacesDropdownsModel {
    race: any;
    uniqueIdentifier: any;
}
export class CityandState {
    CITY_NAME: any;
    STATE_CODE: any;
}
export class CityandStateRequest {

    ZIP_CODE: any;
}
export class GetEnthincitiesDropdownsModel {
    ethnicities: any;
    uniqueIdentifier: any;
}
export class GetLanguageDropdownsModel {
    languages: any;
}
export class SearchPatientPharmacyModel {
    patientAccount: any = '';
    pharmacyAddress: any = '';
    pharmacyFax: any = '';
    pharmacyPhone: any = '';
    pharmacyState: any = '';
    pharmacyCity: any = '';
    pharmacyZip: any = '';
    pharmacyName: any = '';
    pharmacyTopRecord: any = '';
}
export class GetETHNICITIES {
    ETHNICITIES: any;
}
export class Getpharmacies {
    PHARMACY_CODE: any;
    PHARMACY_NAME: any;
    PHARMACY_ADDRESS: any;
    PHARMACY_ZIP: any;
    PHARMACY_CITY: any;
    PHARMACY_STATE: any;
    PHARMACY_FAX: any;
    NCPDPID: any;
    NPI: any;
    SERVICELEVEL: any;
    PHARMACY_PHONE: any;
    ENDDATE: any;
    id: any;
}
